<template>
  <div class="editBtn">
    <!-- file format -->
    <el-dropdown
      class="fileFormat"
      trigger="click"
      @visible-change="dropdownClick"
      placement="bottom-start"
    >
      <span class="el-dropdown-link">
        <img src="@/assets/imgs/cloudSpace/hms_arrow.webp" alt="" />{{
          getFileType(fileType)
        }}
      </span>
      <el-dropdown-menu slot="dropdown" :appendToBody="false">
        <el-dropdown-item
          @click="dropdownChange"
          v-for="(item, index) in options.fileFormat"
          :key="index"
        >
          <template>
            <div @click="dropdownChange(item.value)" class="lang-items">
              <span>{{ item.lable }}</span>
            </div>
          </template>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- files edit -->
    <div
      class="filesEdit"
      v-for="(item, index) in options.fileEdit"
      :key="index"
      @mouseover.stop="handleMouseOver(index)"
      @mouseleave.stop="handleMouseLeave(index)"
    >
      <el-button
        :class="[`${item.value}-icon`, 'fileEdit']"
        @click="handlerClick(item.value)"
        v-show="hiddenBtn(item)"
      >
        <template>
          <div class="slot editBtn-slot">
            <img class="editBtn-slot-img" :src="getIcon(item, index)" alt="" />
            <span class="editBtn-slot-text">{{ item.lable }}</span>
          </div>
        </template>
      </el-button>
    </div>
    <!-- files view -->
    <el-radio-group
      class="fileView"
      v-model="fileViewNew"
      @change="fileViewChange"
      @mouseleave.stop="fileViewLeave(index)"
      @mouseover.stop="fileViewOver(index)"
    >
      <el-radio-button
        v-for="(item, index) in options.fileView"
        :key="index"
        :label="item.value"
      >
        <img :src="require(`@/assets/imgs/cloudSpace/${item.icon}`)" alt="" />
      </el-radio-button>
    </el-radio-group>
    <!-- tips -->
    <div
      class="tips"
      v-show="fileList.length > 0 || downloadFileList.length > 0"
    >
      <img src="@/assets/imgs/cloudSpace/information.webp" alt="" />
      <span>{{ $t("avoid_refresh_transfer") }}</span>
    </div>
  </div>
</template>
<script>
import { renameFile, delFiles } from "@/api/network/printer";
import { importModel } from "@/api/slicer/printer";
import { mapState } from "vuex";
export default {
  name: "fileEdit",
  props: {
    fileType: {
      type: Number,
      default: () => 0,
    },
    fileView: {
      type: String,
      default: () => "list",
    },
    fromList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    fileView: {
      handler(val) {
        this.fileViewNew = val;
      },
      immediate: true,
    },
    "fromList.length": {
      handler(newVal, oldVal) {
        if (newVal > oldVal) {
          this.options.fileEdit[0].iconShow = this.fromList.every(
            (item) => item.checkbox
          )
            ? true
            : false;
        }
      },
    },
  },
  data() {
    return {
      options: {
        fileFormat: [
          { value: 0, lable: this.$t("all_files") },
          { value: 1, lable: ".3mf" },
          { value: 2, lable: ".gcode" },
          { value: 3, lable: ".stl/.obj" },
          { value: 4, lable: this.$t("other_files") },
        ],
        fileEdit: [
          {
            lable: this.$t("select_all"),
            value: "SelectAll",
            icon: "Select All.webp",
            clickIcon: "Select All_select.webp",
            iconShow: false,
          },
          {
            lable: this.$t("download"),
            value: "download",
            icon: "Download.webp",
            clickIcon: "download-click-small.webp",
            iconShow: false,
          },
          {
            lable: this.$t("import"),
            value: "Import",
            icon: "Import.webp",
            clickIcon: "Import-click.webp",
            iconShow: false,
          },
          {
            lable: this.$t("delete"),
            value: "Delete",
            icon: "Delete.webp",
            clickIcon: "Delete-click.webp",
            iconShow: false,
          },
        ],
        fileView: [
          {
            lable: "List",
            value: "list",
            icon: "list.webp",
            hover: "list-hover.webp",
            iconShow: false,
          },
          {
            lable: "Grid",
            value: "grid",
            icon: "grid.webp",
            hover: "grid-hover.webp",
            iconShow: false,
          },
        ],
      },
      fileViewNew: null,
    };
  },
  computed: {
    ...mapState({
      fileList: (state) => state.user.fileList,
      downloadFileList: (state) => state.user.downloadFileList,
    }),
    getFileType() {
      return (val) => {
        const index = this.options.fileFormat.findIndex(
          (item) => val == item.value
        );
        return this.options.fileFormat[index]?.lable;
      };
    },
    getView() {
      return this.fromList.some((item) => item.checkbox);
    },
    getIcon() {
      return (item, b) => {
        return item.iconShow
          ? require(`@/assets/imgs/cloudSpace/${item.clickIcon}`)
          : require(`@/assets/imgs/cloudSpace/${item.icon}`);
      };
    },
    hiddenBtn() {
      return (obj) => {
        let faild = false;
        let arr = [];
        const fileTypeArr1 = ["3mf", "gcode"];
        const fileTypeArr2 = ["stl", "step", "svg", "obj", "amf"];

        switch (obj.value) {
          case "SelectAll":
            faild = true;
            break;
          case "Import":
            //  1 多选仅模型文件支持导入；
            //  2 单选 3MF 或者 Gcode 支持导入,其他场景都不允许
            arr = [...this.fromList].filter((item) => item.checkbox);
            if (arr.some((item) => item.fileStateStr != "import")) return;
            if (arr.length == 1) {
              const type = arr[0]?.file_extension?.toLowerCase();
              faild =
                fileTypeArr1.includes(type) || fileTypeArr2.includes(type);
            } else if (arr.length > 1) {
              faild = arr.every((item) =>
                fileTypeArr2.includes(item?.file_extension?.toLowerCase())
              );
            }
            break;
          case "download":
            arr = [...this.fromList].filter(
              (item) => item.checkbox && item.fileStateStr == "default"
            );
            faild = arr.length > 0;
            break;
          default:
            faild = [...this.fromList].some((item) => item.checkbox);
          // case 'SelectAll':
          //   faild = true;
          //   break;
          // case 'SelectAll':
          //   faild = true;
          //   break;
        }
        return faild;
      };
    },
  },
  created() {
    // mac下展示隐藏掉导入按钮
    // const type = this.$common.getSliceType()
    // if (type !== "win") {
    //   this.options.fileEdit = this.options.fileEdit.splice(3, 1)
    // }
  },
  methods: {
    handleMouseOver(index) {
      this.options.fileEdit[index].iconShow = true;
    },
    handleMouseLeave(index) {
      if (index == 0) {
        this.options.fileEdit[index].iconShow = this.fromList.every(
          (item) => item.checkbox
        );
      } else {
        this.options.fileEdit[index].iconShow = false;
      }
    },
    dropdownChange(value) {
      if (value == this.fileType) return;
      this.$emit("update:fileType", value);
    },
    fileViewChange(value) {
      this.$emit("update:fileView", value);
    },
    //  下拉点击
    dropdownClick(val) {
      if (val) {
        this.$el
          .getElementsByClassName("el-dropdown-link")[0]
          .querySelectorAll("img")[0].style.transform = "rotateZ(180deg)";
      } else {
        this.$el
          .getElementsByClassName("el-dropdown-link")[0]
          .querySelectorAll("img")[0].style.transform = "";
      }
    },
    //  按钮点击
    handlerClick(str) {
      console.log(str);

      switch (str) {
        case "SelectAll":
          this.filesSelectAll();
          break;
        case "Delete":
          this.filesDelete();
          break;
        case "Import":
          this.filesImport();
          break;
        case "download":
          this.filesDownload();
          break;
      }
    },
    //  导入
    filesImport() {
      const importStr = this.fromList
        .filter((item) => item.checkbox)
        .map((item) => item.old_filename)
        .join("?");
      importModel(importStr, 0);
    },
    //  全选
    filesSelectAll() {
      const fild = [...this.fromList]
        .filter((item) => item.percentage != 0 && item.percentage != 1)
        .every((item) => item.checkbox);
      const arr = [...this.fromList].map((item, index) => {
        if (item.percentage != 0 && item.percentage != 1) {
          this.$set(item, "checkbox", !fild);
        }
        return item;
      });
      this.$emit("filesChange", "update", arr);
    },
    //  删除
    async filesDelete() {
      this.$confirm(this.$t("confirm_delete"), this.$t("tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("Cancel"),
        type: "warning",
        center: true,
        customClass: this.$store.getters.GET_IS_DARK ? "dark-model" : "",
      })
        .then(() => {
          this.del();
        })
        .catch(() => {
          // this.$message.info("已取消删除!");
        });
    },
    async del() {
      const idArr = [...this.fromList]
        .filter((item) => item.checkbox)
        .map((item) => item.id);

      const res = await delFiles({ idArr });
      if (res.code != 1) return;
      //  删除文件
      const arr = [...this.fromList].filter((item) => !item.checkbox);
      this.$emit("filesChange", "delete", idArr);
    },
    //  下载
    filesDownload() {
      const arr = [...this.fromList].filter(
        (item) => item.checkbox && item.fileStateStr == "default"
      );
      if (arr.length > 1) {
        this.$confirm(this.$t("confirm_download_all"), this.$t("tips"), {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("Cancel"),
          type: "warning",
          center: true,
          customClass: this.$store.getters.GET_IS_DARK ? "dark-model" : "",
        })
          .then(() => {
            this.$emit("fileDownload", arr);
          })
          .catch(() => {
            // this.$message.info("已取消删除!");
          });
      } else {
        this.$emit("fileDownload", arr);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.editBtn {
  .fileFormat {
    color: var(--VI-color);
    font-size: 14px;
    line-height: 22px;
    border-radius: 6px;
    cursor: pointer;
    padding: 3px 21px 3px 10px;
    float: left;
    margin-right: 8px;

    span {
      display: flex;
      align-items: center;

      img {
        margin-right: 4px;
      }
    }
  }

  .fileFormat:hover,
  .fileFormat:active {
    background: var(--print-setting-background-color);
  }

  .filesEdit {
    float: left;
    margin-right: 16px;
  }

  .fileView {
    float: right;
  }

  .tips {
    float: right;
    margin-right: 16px;
    background: rgba(255, 103, 0, 0.06);
    border-radius: 28px;
    padding: 5px 14px;
    display: flex;
    align-items: center;

    img {
      margin-right: 4px;
    }

    span {
      font-size: 13px;
      color: #ff6700;
      line-height: 18px;
    }
  }

  .file-edit-box {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  &-slot {
    display: flex;
    align-items: center;

    &-img {
      margin-right: 4px;
    }

    &-text {
      color: var(--three-text-color);
      font-size: 14px;
      line-height: 16px;
    }
  }
}

.editBtn::after {
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

::v-deep {
  .el-radio-button__inner {
    background: var(--print-setting-background-color);
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: var(--VI-color);
  }

  .el-radio-button--small .el-radio-button__inner {
    padding: 5px 21px;
    border: none;
    display: flex;
  }

  .el-divider--vertical {
    margin: 0 16px;
  }

  .el-button {
    &--small {
      padding: 4px 10px !important;
    }

    &--default:hover,
    &--default:active {
      background: none;

      .editBtn-slot-text {
        color: var(--VI-color);
      }
    }

    &--default.Import-icon:hover {
      border-color: #ff6700;

      .editBtn-slot-text {
        color: #ff6700;
      }
    }

    &--default.Delete-icon:hover {
      border-color: #ff3a34;

      .editBtn-slot-text {
        color: #ff3a34;
      }
    }
  }

  .el-dropdown-menu {
    padding: 4px;
    margin-top: 6px;
    background: var(--dialog-background-color);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 6px 6px 6px 6px;
    border: 1px solid var(--input-border-color);

    .popper__arrow {
      display: none;
    }
  }

  .el-dropdown-menu__item {
    color: var(--first-text-color);
    width: 125px;
    line-height: 24px;
    font-size: 13px;
    border: 1px solid var(--dialog-background-color);
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background: var(--dialog-background-color);
    color: var(--first-text-color);
    border: 1px solid var(--VI-color);
  }
}
</style>
